module.exports = __webpack_public_path__ + "static/media/icn_quarantined_covid_myway.d1413f90.svg";